// Material Kit 2 PRO React components
import MKTypography from "components/MKTypography";

// Images
import logo from "assets/images/logo-ct-dark.png";

import projects from "pages/Home/projects";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "HALYARD LLC",
    image: logo,
    route: "/",
  },
  socials: [],
  menus: [
    {
      name: "Our projects",
      items: projects.map((project) => ({ name: project.name, route: `/#${project.id}` })),
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      All rights reserved. Copyright &copy; {date}{" "}
      <MKTypography
        component="a"
        href="https://www.halyardtech.com"
        target="_blank"
        rel="noreferrer"
        variant="button"
        fontWeight="regular"
      >
        Halyard LLC
      </MKTypography>
      .
    </MKTypography>
  ),
};
